const PRODUCTION_URL = 'app.surglogs.com'
const PRODUCTION_AUTH_URL = 'auth.surglogs.com'
const PRODUCTION_AUDITS_URL = 'audits.surglogs.com'

export const isProductionApp = () => window.location.hostname === PRODUCTION_URL

export const isProductionAuthApp = () =>
  window.location.hostname === PRODUCTION_AUTH_URL

export const isProductionAuditsApp = () =>
  window.location.hostname.includes(PRODUCTION_AUDITS_URL)
